import * as React from 'react';

import { Field } from 'redux-form';

import grey from '@material-ui/core/colors/grey';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import type { JobFieldProps } from './job-field';

import { RequiredLicenseWarning } from '../required-license-warning';

import { JobField } from './job-field';

import { JobLicenseReduxFormField } from '../../widgets/redux-form-fields/job-license-redux-form-component';

const styles = () =>
  createStyles({
    formField: {
      width: '100%',
    },
    experienceHeader: {
      marginTop: '8px',
      background: grey[200],
      borderBottom: `1px solid ${grey[500]}`,
    },
    experienceRow: {
      '&:last-child': {
        borderBottom: `1px solid ${grey[500]}`,
      },
    },
    name: {
      verticalAlign: 'middle',
    },
  });

interface Props extends JobFieldProps, WithStyles<typeof styles> {
  jobId: number;
  jobDetails: JobDetails;
  suggestions?: string | null;
}

class JobFieldLicenseComponent extends React.PureComponent<Props> {
  render() {
    const { classes, jobId, jobDetails, suggestions } = this.props;
    const { classes: _, ...childrenProps } = this.props;
    return (
      <div className={classes.formField}>
        <JobField
          {...childrenProps}
          title="Relevant Licenses/Certifications"
          caption='Add licenses that are relevant to this job. Check "Required" if you only want to see applicants that explicitly state they have this certification.'
          editView={
            <Field
              name="relevantLicenses"
              component={JobLicenseReduxFormField}
              jobId={jobId}
              suggestions={suggestions}
            />
          }
          displayView={
            jobDetails.relevantLicenses.length > 0 ? (
              <>
                <Table>
                  <TableHead className={classes.experienceHeader}>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Required</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {jobDetails.relevantLicenses.map(
                      (l) =>
                        l.isActive && (
                          <TableRow
                            key={`job-license-${l.jobLicenseId || ''}`}
                            className={classes.experienceRow}
                          >
                            <TableCell>
                              <Typography variant="body2">
                                <span className={classes.name}>{l.license.license_name}</span>
                              </Typography>
                            </TableCell>
                            <TableCell>{l.isRequired ? 'Yes' : 'No'}</TableCell>
                          </TableRow>
                        ),
                    )}
                  </TableBody>
                </Table>
                <RequiredLicenseWarning
                  requiredLicenseNames={jobDetails.relevantLicenses
                    .filter((l) => l.isRequired)
                    .map((l) => l.license.license_name)}
                />
              </>
            ) : (
              <Typography variant="body2">This job has no relevant licenses.</Typography>
            )
          }
        />
      </div>
    );
  }
}

export const JobFieldLicense = withStyles(styles)(JobFieldLicenseComponent);
